import { Outlet } from 'react-router-dom';
import { PlatformFooter } from './PlatformFooter';
import { PlatformHeader } from './PlatformHeader';
import { PlatformSidebar } from './PlatformSidebar';

export function PlatformLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <PlatformSidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <PlatformHeader />
        <main className="flex-1 min-h-0 overflow-auto p-6">
          <Outlet />
        </main>
        <PlatformFooter />
      </div>
    </div>
  );
}
